<template>
    <figure v-if="image" :class="{ cover }">
        <div class="figureHolder">
            <div class="filler" :style="{ paddingTop: image.height / image.width * 100 + '%' }"></div>
            <Image :image="image" :width="width" :height="height" :mobileHeight="mobileHeight" :mobileWidth="mobileWidth" :imageClass="cover ? 'cover' : ''" />
            <div :class="['copy', 'baron', 'headerText', { light: image.light_caption }]" v-if="image.description">{{ image.description.toLowerCase() }}</div>
        </div>
        <figcaption v-if="caption">{{ caption }}</figcaption>
    </figure>
</template>

<script lang="ts" setup>
interface Props {
    image: any;
    caption?: string;
    cover?: boolean;
    width?: number;
    height?: number;
    mobileHeight?: number;
    mobileWidth?: number;
}

withDefaults(defineProps<Props>(), {
    width: 582,
    cover: false
})
</script>

<style lang="scss" scoped>
figure {
    display: flex;
    flex-direction: column;
    gap: var(--size-margin-page);

    .figureHolder {
        position: relative;
        width: 100%;
        background-color: #fafafa;

        &:deep(.responsivePicture) {
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 100%;
        }
    }

    .copy {
        position: absolute;
        bottom: var(--size-margin-page);
        right: var(--size-margin-page);

        &.light {
            color: white
        }
    }

    figcaption {
        font-size: var(--text-size-bodyxs);
        line-height: var(--text-line-bodyxs);
    }

    &.cover {
        width: 100%;
        height: 100%;

        .figureHolder {
            height: 100%;
        }
    }
}
</style>